<template>
  <!------------- See Profile Section --------------->
  <v-card flat>
    <!------------- Start Back Button Section --------------->
    <v-card flat class="d-flex justify-end">
      <router-link to="/users" style="text-decoration: none">
        <v-btn depressed color="transparent" class="d-flex justify-end">
          Back
        </v-btn>
      </router-link>
    </v-card>
    <!------------- End Back Button Setion --------------->

    <v-card color="transparent" flat>
      <!------------- Profile Section --------------->
      <div>
        <template v-for="item in items">
          <div class="d-flex justify-start mb-6" :key="item.title">
            <v-avatar size="150">
              <img :src="item.avatar" />
            </v-avatar>
            <div class="mt-10 px-10">
              <div v-html="item.name"></div>
              <div v-html="item.email"></div>
            </div>
          </div>
        </template>
      </div>
      <!------------- End Profile --------------->
      <div>
        <!------------- Start Tabs  --------------->

        <v-tabs flat v-model="tabs" class="tabs_slider">
          <v-tab style="text-transform: none !important"
            ><b>Profile/Credentials</b></v-tab
          >
          <v-tab style="text-transform: none !important"
            ><b>Membership</b></v-tab
          >
          <v-tab style="text-transform: none !important"
            ><b>Purchases & Billing</b></v-tab
          >

        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat style="width: 600px">
              <div class="mt-10 d-flex justify-space-between heading-2">
                Profile settings
                <!------------- start Edit  Presonal Information Dialog --------------->
                <v-dialog v-model="editdialog" width="500" persistent>
                  <template v-slot:activator="{ on, attrs }" class="px-10">
                    <div class="d-flex justify-end">
                      <v-btn
                        rounded
                        outlined
                        color="#1884CD"
                        class="px-9"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="
                          text-transform: none !important;

                          border: 1px solid #d2e5fc;
                        "
                        >Edit
                      </v-btn>
                    </div>
                  </template>
                  <v-card>
                    <div class="mx-5 py-5 d-flex justify-space-between">
                      <h5>Personal info</h5>
                      <v-icon @click="editdialog = false">mdi-close</v-icon>
                    </div>
                    <div>
                      <edit-personalinfo />
                    </div>
                    <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8 pa-3">
                      <v-btn
                        class="px-10 py-6"
                        color="#A1A3A8"
                        text
                        @click="editdialog = false"
                        style="text-transform: none"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        depressed
                        color="primary"
                        class="px-14 py-6"
                        style="text-transform: none"
                        @click="send()"
                      >
                        <span v-if="btnloader != true"> Save </span>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog>
                <!------------- End Edit  Presonal Information Dialog --------------->
              </div>
            </v-card>
            <!------------- start Presonal Information  --------------->

            <v-card flat style="width: 630px">
              <v-row class="mt-3">
                <v-col cols="12" md="3">
                  <div>
                    <span
                      class="style_txt_hh1"
                      style="color: rgba(34, 34, 34, 0.7)"
                      >Username</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <div><span class="style_txt_hh2">Axel </span></div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">First name</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div><span class="style_txt_hh2">Axel</span></div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Last name</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div><span class="style_txt_hh2">Camiletti</span></div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Phone Number</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div><span class="style_txt_hh2">+11 5575 2454</span></div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Date registered</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div><span class="style_txt_hh2">11/12/2021</span></div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Membership</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div>
                    <span class="style_txt_hh2"
                      ><router-link to="/Practitioners"
                        >Practitioner
                      </router-link></span
                    >
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Password</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div>
                    <span class="style_txt_hh2">***********</span>
                    <v-icon class="mx-4 mt-n3" color="#52AE32">mdi-lock</v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Webpage URL</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div>
                    <span class="style_txt_hh2">axel@axelbodytalk.com</span>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Spcialization</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <v-chip v-chip color="#F7F8FC" label> Label1 </v-chip>
                  <span class="">
                    <v-chip class="ma-1" color="#F7F8FC" label> Label2 </v-chip>
                  </span>
                  <v-chip color="#F7F8FC" label> Id </v-chip>
                  <span class="">
                    <v-chip class="ma-1" color="#F7F8FC" label> nunc </v-chip>
                  </span>
                  <v-chip color="#F7F8FC" label> ipsum </v-chip>
                  <span class="">
                    <v-chip class="ma-1" color="#F7F8FC" label>
                      adipiscing
                    </v-chip>
                  </span>
                  <v-chip color="#F7F8FC" label> sit </v-chip>
                  <span class="">
                    <v-chip class="ma-1" color="#F7F8FC" label> urna </v-chip>
                  </span>
                  <v-chip color="#F7F8FC" label> viverra </v-chip>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Intro Description</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div>
                    <span class="style_txt_hh2">axel sees the clients the greater Los Angeles area and ..
                    </span>
                  </div>
                </v-col>
              </v-row>
               <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <div><span class="style_txt_hh1">Bio</span></div>
                </v-col>
                <v-col cols="12" md="9">
                  <div>
                    <span class="style_txt_hh2">I took my bodytalk class in 2009 and was insatanly..
                
                    </span>
                  </div>
                </v-col>
              </v-row>
              <!-- <v-row class="mt-1">
                <v-col cols="12" md="3">
                  <span class="style_txt_hh1">
                    <router-link
                      to="/users/profile"
                      class="text-decoration-underline"
                      >View Bio
                    </router-link>
                  </span>
                </v-col>
              </v-row> -->
            </v-card>
            <!------------- End Presonal Information  --------------->
            <v-divider class="my-7 devider_style"> </v-divider>
            <!------------- start Address --------------->
            <v-card flat style="width: 600px">
              <div class="mt-10 d-flex justify-space-between heading-2">
                Addresses

                <!------------- start Edit  Presonal Information Dialog --------------->
                <v-dialog v-model="editAddressdialog" width="500" persistent>
                  <template v-slot:activator="{ on, attrs }" class="px-10">
                    <div class="d-flex justify-end">
                      <v-btn
                        rounded
                        outlined
                        color="#1884CD"
                        class="px-9"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="
                          text-transform: none !important;
                          border: 1px solid #d2e5fc;
                        "
                        >Edit
                      </v-btn>
                    </div>
                  </template>
                  <v-card>
                    <div class="mx-5 py-5 d-flex justify-space-between">
                      <h5>Personal Info</h5>
                      <v-icon @click="editAddressdialog = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div class="mx-5">
                      <v-text-field label="Address"></v-text-field>
                      <div class="mt-3">
                        <p class="">
                          Should the address be visible publicly, YES or NO
                        </p>
                        <div class="mx-3">
                          <b-form-radio
                            v-model="publiclyRadio"
                            value="Yes"
                            class="mb-2"
                            >Yes</b-form-radio
                          >
                          <b-form-radio v-model="publiclyRadio" value="No"
                            >No</b-form-radio
                          >
                        </div>
                      </div>
                      <div class="mt-6">
                        <p class="">
                          Is this address a clinic address or home address?
                        </p>
                        <div class="mx-3">
                          <b-form-checkbox
                            class="mb-2"
                            v-model="ClinicCheckbox"
                          >
                            Clinic </b-form-checkbox
                          ><b-form-checkbox v-model="HomeCheckbox">
                            Home
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="mt-6">
                        <p class="">Is this your shipping address?</p>
                        <div class="mx-3">
                          <b-form-radio
                            v-model="shippingAddressRadio"
                            value="Yes"
                            class="mb-2"
                            >Yes</b-form-radio
                          >
                          <b-form-radio
                            v-model="shippingAddressRadio"
                            value="No"
                            >No</b-form-radio
                          >
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8 pa-3">
                      <v-btn
                        class="px-10 py-6"
                        color="#A1A3A8"
                        text
                        @click="editAddressdialog = false"
                        style="text-transform: none"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        depressed
                        color="primary"
                        class="px-14 py-6"
                        style="text-transform: none"
                        @click="send()"
                      >
                        <span v-if="btnloader != true"> Save </span>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog>
                <!------------- End Edit  Presonal Information Dialog --------------->
              </div>
            </v-card>
            <div>
              <div
                class="mt-5 d-flex justify-start"
                v-for="(item, index) in addressitems"
                :key="index"
              >
                <div class="d-flex justify-start">
                  <v-icon class="" style="color: #222222">mdi-truck</v-icon>
                </div>
                <div class="px-4 d-flex justify-start index_h1_text_style">
                  {{ item.address}}
                </div>
                <!------------- start Address Dialog --------------->
                <v-icon
                  block
                  @click="(addreseditdialog = true), (SuccessToast = false)"
                >
                  mdi-pencil
                </v-icon>
                <!-- <v-dialog v-model="addreseditdialog" width="500" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="px-2 d-flex justify-start">
                      <v-icon
                        outlined
                        color="#a8a7a7"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >mdi-pencil</v-icon
                      >
                    </div>
                  </template>
                  <v-card>
                    <div class="mx-5 py-5 d-flex justify-space-between">
                      <h5 style="text-transform: none">Personal Info</h5>
                      <v-icon @click="addreseditdialog = false"
                        >mdi-close</v-icon></div>
                    <div><edit-user-address/></div>
                    <div class="d-flex justify-end mx-5 py-5 pb-8 pt-8">
                      <v-btn
                        class="px-14 py-6"
                        color="#A1A3A8"
                        text
                        @click="addreseditdialog = false"
                        style="text-transform: none">
                        Cancel
                      </v-btn>
                      <v-btn
                        depressed
                        color="primary"
                        class="px-14 py-6"
                        style="text-transform: none"
                        @click="send()" >
                        <span v-if="btnloader != true"> Save </span>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog> -->
                <div class="d-flex justify-start">
                  <v-icon style="color: #f52626"> mdi-delete-outline </v-icon>
                </div>
              </div>
            </div>
            <!------------- End Address Dialog --------------->
            <!------------- start Address  --------------->
           
          </v-tab-item>

          <v-tab-item>
            <!------------- start Memebership --------------->
            <div class="mt-10 d-flex justify-space-between heading-2">
              Membership
              <!------------- start Edit  MemberShip Dialog --------------->
              <v-dialog v-model="Membereditdialog" width="500" persistent>
                <template v-slot:activator="{ on, attrs }" class="px-10">
                  <div class="d-flex d-flex justify-space-between">
                    <v-btn
                      rounded
                      outlined
                      color="#1884CD"
                      class="px-9"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      style="
                        text-transform: none !important;

                        border: 1px solid #d2e5fc;
                      "
                      >Edit</v-btn
                    >
                  </div>
                </template>
                <v-card>
                  <div class="mx-5 py-5 d-flex justify-space-between">
                    <h5>Membership</h5>
                    <v-icon @click="Membereditdialog = false">mdi-close</v-icon>
                  </div>
                  <div>
                    <membership-view />
                  </div>
                  <div class="d-flex justify-end mx-5 py- pt-8 pb-8">
                    <v-btn
                      class="px-10 py-6 text_transform"
                      color="#A1A3A8"
                      text
                      @click="Membereditdialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      color="primary"
                      class="px-14 py-6 text_transform"
                      @click="send()"
                    >
                      <span v-if="btnloader != true"> Save </span>
                      <v-progress-circular
                        indeterminate
                        size="20"
                        class="px-5"
                        color="white"
                        v-show="btnloader"
                      ></v-progress-circular>
                    </v-btn>
                  </div>
                </v-card>
              </v-dialog>
              <!------------- End Edit MemeberShip  Dialog --------------->
            </div>
            <!------------- Start MemberShip Information --------------->
            <div class="mt-4 mb-12">
              <v-card flat style="width: 500px">
                <v-row class="mt-2">
                  <v-col cols="12" md="3">
                    <div><span class="style_txt_hh1">Membership</span></div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div><span class="style_txt_hh2">Practitioner</span></div>
                  </v-col>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="12" md="3">
                    <div><span class="style_txt_hh1">Frecuency</span></div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div><span class="style_txt_hh2">Anually</span></div>
                  </v-col>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="12" md="3">
                    <div><span class="style_txt_hh1">Amount</span></div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div><span class="style_txt_hh2">$99 / year</span></div>
                  </v-col>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="12" md="3">
                    <div>
                      <span class="style_txt_hh1">Date membership</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div>
                      <span class="style_txt_hh2">11/12/2021 - 11/12/2022</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="12" md="3">
                    <div><span class="style_txt_hh1">Auto Renewal</span></div>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div><span class="style_txt_hh2">Yes</span></div>
                  </v-col>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="12" md="3">
                    <span class="style_txt_hh1">
                      <router-link
                        to="/users/profile"
                        class="text-decoration-underline"
                        >Add Payment
                      </router-link>
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!------------- End MemberShip Information --------------->
            <v-divider
              class="my-7 mt-4"
              style="opacity: 0.1; border: 1px solid #000000"
            >
            </v-divider>
            <!------------- Invoices --------------->
            <div class="mt-6 mb-8 d-flex justify-space-between heading-2">
              Invoices
              <!------------- Dialog Billing Information--------------->
              <v-dialog v-model="billingeditdialog" width="500" persistent>
                <template v-slot:activator="{ on, attrs }" class="px-10">
                  <div class="d-flex d-flex justify-space-between">
                    <v-btn
                      rounded
                      outlined
                      color="primary"
                      class="px-4 stying_text"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      >Edit Billing Info</v-btn
                    >
                  </div>
                </template>
                <v-card>
                  <div class="mx-5 py-5 d-flex justify-space-between">
                    <h5>Billing Info</h5>
                    <v-icon @click="billingeditdialog = false"
                      >mdi-close</v-icon
                    >
                  </div>
                  <div>
                    <billing-inf-edit />
                  </div>
                  <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8">
                    <v-btn
                      class="px-10 py-6 text_transform"
                      color="#A1A3A8"
                      text
                      @click="billingeditdialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      color="primary"
                      class="px-14 py-6 text_transform"
                      @click="send()"
                    >
                      <span v-if="btnloader != true"> Save </span>
                      <v-progress-circular
                        indeterminate
                        size="20"
                        class="px-5"
                        color="white"
                        v-show="btnloader"
                      ></v-progress-circular>
                    </v-btn>
                  </div>
                </v-card>
              </v-dialog>
              <!------------- End Dialog Billing Information --------------->
            </div>
            <!------------- Datatable Invoices--------------->
            <v-card class="mt-2 mb-14" outlined flat>
              <v-data-table
                :headers="headers"
                :items="DataTableOne"
                :hide-default-footer="true"
                class="mytable"
              >
                <template v-slot:[`item.actions`]>
                  <!------------- Invoices Dailog--------------->
                  <v-icon color="#A1A1A6" @click="invoicedialog = true">
                    mdi-file-document
                  </v-icon>
                  <v-icon color="#A1A1A6" class="pl-2"> mdi-delete </v-icon>
                  <!------------- End Invoices Dailog --------------->
                </template>
              </v-data-table>
              <!------------- End Invoices datatables-------------->
            </v-card>
          </v-tab-item>
          <!------------- start Memebership information   -------------->
          <v-tab-item>
            <v-card flat>
              <div class="mt-10 d-flex justify-end heading-2">
                <v-dialog v-model="Memberinfoeditdialog" width="500" persistent>
                  <template v-slot:activator="{ on, attrs }" class="px-10">
                    <div class="d-flex justify-end">
                      <v-btn
                        rounded
                        outlined
                        color="#1884CD"
                        class="px-9 stying_text mb-5"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >Add Payment</v-btn
                      >
                    </div>
                  </template>
                  <v-card>
                    <div class="mx-5 py-5 d-flex justify-space-between">
                      <h5>Membership</h5>
                      <v-icon @click="Memberinfoeditdialog = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div>
                      <memberinfo />
                    </div>
                    <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8">
                      <v-btn
                        class="px-10 py-6 text_transform"
                        color="#A1A3A8"
                        text
                        @click="Memberinfoeditdialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        class="px-14 py-6 text_transform"
                        @click="send()"
                      >
                        <span v-if="btnloader != true"> Save </span>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog>
                <!------------- End Memebership information dialog  -------------->
              </div>
              <v-card class="mt-2 mb-14" outlined flat>
                <v-data-table
                  :headers="orderheaders"
                  :items="DataTableTwo"
                  :hide-default-footer="true"
                  class="mytable"
                >
                  <template v-slot:[`item.actions`] class="d-flex justify-end">
                    <!------------- Invoices Dailog--------------->
                    <div class="text-center">
                      <router-link to="/users/userorder">
                        <v-btn depressed outlined color="primary">
                          View Details
                        </v-btn>
                      </router-link>
                    </div>
                    <!------------- End Invoices Dailog --------------->
                  </template>
                </v-data-table>
              </v-card>
            </v-card>
          </v-tab-item>
          <!------------- End Memebership information  -------------->
          
        </v-tabs-items>
        <!------------- End Tabs --------------->
      </div>
    </v-card>
    <v-dialog
      v-model="invoicedialog"
      max-width="1024"
      @click:outside="closeDialog"
    >
      <div>
        <invoices />
      </div>
    </v-dialog>
    <!-- <v-dialog v-model="editexam" persistent max-width="400">
      <v-card>
        <div>
          <edit-exam :editexam="editexam" @close="close" />
        </div>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="addreseditdialog" persistent max-width="400">
      <v-card>
        <div>
          <edit-user-address
            :addreseditdialog="addreseditdialog"
            @close="close"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
//import AddExam from "./add-exam.vue";
import BillingInfEdit from "../../components/practitioners/BillingInfEdit-practioner.vue";
//import EditExam from "./Edit-exam.vue";
import EditUserAddress from "../../components/practitioners/EditAddressuser-practioner.vue";
import EditPersonalinfo from "../../components/practitioners/EditPersonalinfo-practioner.vue";
import Invoices from "../../components/practitioners/invoices-practioner.vue";
import Memberinfo from "../../components/practitioners/memberinfo-practioner.vue";
import MembershipView from "../../components/practitioners/MembershipView-practioner.vue";

export default {
  components: {
    EditPersonalinfo,
    MembershipView,
    BillingInfEdit,
    Invoices,
    Memberinfo,
    EditUserAddress,
   // AddExam,
   // EditExam,
  },

  name: "seeprofilecomponent",
  data() {
    return {
      CEUsearch: "",
      shippingAddressRadio: "",
      ClinicCheckbox: false,
      HomeCheckbox: false,
      publiclyRadio: "",
      editAddressdialog: false,
      invoicedialog: false,
      Memberinfoeditdialog: false,
      Membereditdialog: false,
      editexam: false,
      editdialog: false,
      billingeditdialog: false,
      addreseditdialog: false,
      btnloader: false,
      btnloader1: false,
      add_dialog: false,
      dialog: false,
      Permission: {},
      name:"axel",
      LastName:"Camelatti",
      addressitems: [
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
      ],
      notesheaders: [
        { text: "Serial Number", value: "serialnumber", sortable: false },
        { text: "Notes", value: "notes", sortable: false },
        { text: " Date Added", value: "dateadded", sortable: false },
        { text: "Added By", value: "addedby", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      notesDataTable: [
        {
          serialnumber: "1",
          notes: "Body talk Fundamentals Extensions",
          dateadded: "12/12/2022",
          addedby: "John veltheim",
        },
        {
          serialnumber: "2",
          notes: "Body talk Fundamentals Extensions and its Extensions ",
          dateadded: "12/12/2022",
          addedby: "John veltheim",
        },
      ],
      credentialsheaders:
      [
         { text: "Date", value: "date", sortable: false },
        { text: "Exam", value: "exam", sortable: false },
        { text: "Instructor", value: "instructor", sortable: false },
        { text: "Written Score", value: "writtenscore", sortable: false },
        { text: "Practical Score", value: "politicalscore", sortable: false },
        { text: " Credential Earned", value: "credentialearn", sortable: false },
        { text: "Certificate", value: "downlaods", sortable: false },
        { text: "", value: "actions", sortable: false },
        
      ],
      credentialsDataTable: [
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "check",
          politicalscore: "56",
          writtenscore:"67",
          credentialearn: "AdvCBP",
        },
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "check",
          politicalscore: "56",
           writtenscore:"67",
          credentialearn: "AdvCBP",
        },
      ],
      examsheaders: [
        { text: "Date", value: "date", sortable: false },
        { text: "Exam", value: "exam", sortable: false },
        { text: "Instructor", value: "instructor", sortable: false },
        { text: "Practical Score", value: "politicalscore", sortable: false },
        { text: "Written Score", value: "writtenscore", sortable: false },
        { text: " Credential ", value: "credential", sortable: false },
        { text: "Certificate", value: "downlaods", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      examsDataTable: [
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "",
          politicalscore: "56",
          credential: "AdvCBP",
        },
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "",
          politicalscore: "56",
          credential: "AdvCBP",
        },
      ],
      CEUheaders: [
        { text: "Date", value: "date", sortable: false },
        { text: "Course", value: "course", sortable: false },
        { text: "Graduate", value: "graduate", sortable: false },
        { text: "Instructor", value: "instructor", sortable: false },
        { text: "Monitor", value: "monitor", sortable: false },
        { text: "Register Date", value: "registerdate", sortable: false },
        { text: "How Registered", value: "register", sortable: false },
        { text: "", value: "actions", sortable: false },
        { text: "", value: "actionss", sortable: false },
      ],
      CEUDataTable: [
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          register: "Website",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          register: "Instructor",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          register: "Admin",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          register: "PaRama Campus",
        },
      ],
      CEUfilterItem: [
        {
          text: "Date",
        },
        {
          text: "Course",
        },
        {
          text: "Instructor",
        },
      ],
      chk: "calle 142,1480,Breaztegui 1448, Areis",
      chk2: "calle 142,1480,Breaztegui 1448, Areis",
      CEUHours: [
        {
          userName: "Miranda jamieson",
          startDate: "04 Jul, 2011 ",
          endDate: "04 Jul, 2013",
        },
      ],
      item: {
        Membership: "Practitioners",
        Frequency: "Anually",
        Amount: "$99/Year",
        DateMemberShip: "11/11/2021-11/11/2022",
        Data6: "3",
        Data7: "15",
      },
      object: {
        UsertName: "Axel",
        FirstName: "Axel",
        LastName: "Camelitti",
        PhoneNumber: "+11 3333432",
        dateRegistered: "11/11/2021",
      },
      object1: {
        Data6: "3",
        Data: "15",
      },
      items: [
        {
          icon: "<v-icon>mdi-truck</v-icon>",
          avatar: "https://picsum.photos/250/300?image=660",
          name: '<span style="font-weight: 700;font-size: 30px;">Alex Camelatti</span> ',
          email: `<span style="color: rgba(34, 34, 34, 0.65);">alex@gmail.com</span> `,
        },
      ],
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Data processed", value: "dateat", sortable: false },
        {
          text: "Payement made through",
          value: "paymentmade",
          sortable: false,
        },
        { text: "Membership", value: "membership", sortable: false },
        { text: "Amount", value: "amount", sortable: false },
        { text: "Payment Made by", value: "paymentmadeby", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [
        {
          index: 4,
          dateat: "11/12/2021",
          paymentmade: "Website",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "Member",
        },
        {
          index: 3,
          dateat: "11/12/2021",
          paymentmade: "Admin",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "IBA Team",
        },
        {
          index: 2,
          dateat: "11/12/2021",
          paymentmade: "Website",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "Member",
        },
        {
          index: 1,
          dateat: "11/12/2021",
          paymentmade: "Admin",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "IBA Team",
        },
      ],
      orderheaders: [
        { text: "Order", value: "order" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        { text: "Date Shipped", value: "dateshiped" },
        { text: "", value: "actions", sortable: false },
      ],

      DataTableTwo: [
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "VOID",
          dateshiped: "",
        },
        {
          order: 98770,
          date: "03/02/2021",
          amount: "$9,999.00",
          status: "VOID",
          dateshiped: "",
        },
        {
          order: 97832,
          date: "11/17/2020",
          amount: "$120.00",
          status: "INVOICED",
          dateshiped: "",
        },
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "INVOICED",
          dateshiped: "",
        },
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "INVOICED",
          dateshiped: "11/12/2021",
        },
        {
          order: 97832,
          date: "11/17/2020",
          amount: "$120.00",
          status: "INVOICED",
          dateshiped: "11/12/2021",
        },
      ],
      tabs: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    };
  },
  methods: {
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
      
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.editexam = false;
        this.addreseditdialog = false;
        this.addreseditdialog = false;
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.Memberinfoeditdialog = false;
        this.editAddressdialog = false;
        this.btnloader = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.tabs_slider {
  color: #1884cd;
  font-weight: 800;
  font-size: 16px;
  line-height: 21px;
  border-bottom: 2px solid #e1e4e7;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(34, 34, 34, 0.7);
}
.style_txt_hh2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #222222;
}
.devider_style {
  width: 590px;
  left: 326px;
  top: 729px;
  opacity: 0.1;
  border: 1px solid #000000;
}
.text_transform {
  text-transform: none;
}
.stying_text {
  text-transform: none !important;
  border: 1px solid #d2e5fc;
}
.text-center {
  text-align: center !important;
}
</style>
